import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Solutions from "../components/Solutions";
import Problems from "../components/Problems";
import Projects from "../components/Projects";
import Process from "../components/Process";
import About from "../components/About";
import CTA from "../components/CTA";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const Home = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Solutions />
      <Problems />
      <Projects />
      <Process />
      <About />
      <CTA />
      <Contact />
    </main>
    <Footer />
  </>
);

export default Home;
